import React from 'react';
import PropTypes from 'prop-types';

import { SvgIcon } from './SvgIcon';

/**
 * @param {object} props - Props.
 * @param {string} [props.code] - Comp abbreviation
 * @param {string} [props.providerId] - Comp ProviderId
 * @param {string} [props.className] - Class(es).
 * @returns {JSX.Element} Component.
 */
export const CompIcon = ({ code, providerId, className = '' }) => {
    let compLogo;
    if (providerId) {
        compLogo = PULSE.app.common.competition.getComp(providerId)?.logo;
    }

    if (!compLogo && code) {
        if (code.toLowerCase() === 'aflw-m') {
            compLogo = 'aflw-logo';
        } else {
            compLogo =
                Object.values(PULSE.app.common.CONSTANTS.COMPETITION).find(
                    (comp) => comp.code.toLowerCase() === code.toLowerCase()
                )?.logo ?? 'afl-logo';
        }
    }

    return <SvgIcon className={className} icon={compLogo} />;
};

CompIcon.propTypes = {
    code: PropTypes.string,
    providerId: PropTypes.string,
    className: PropTypes.string
};
